/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import _ from "lodash";
import { EventbusService } from "./eventbus-service";
import CONFIG from '../../config/default.config.json';
import { IMQTTServiceConfig, MqttService } from "../mqtt-service";
import axios from 'axios';

export interface ITokenDisplayServiceArgs {
  mqttConfig: IMQTTServiceConfig;
  topics: string[];
}

export class TokenDisplayService {
  private static instance: TokenDisplayService;
  private readonly tokenDisplayEventBus: any;
  private readonly mqttEventBus: any;
  private mqttSrv: MqttService;
  private qStore: any;
  private constructor(props: ITokenDisplayServiceArgs | any = {}) {
    this.tokenDisplayEventBus = EventbusService.getInstance()?.getEventBus();
    this.mqttSrv = MqttService.getInstance(props?.mqttConfig);
    this.mqttEventBus = this.mqttSrv?.getEventBus();
    if (this.mqttEventBus) {
      this.mqttEventBus.on("connect", () => {
        console.log("connected");
        if (props.topics) {
          console.log("sub topic ")
          this.mqttSrv.subscribeTopics(props.topics);
        }
      });
      this.mqttEventBus.on("message", this.mqttMsgEventHandler.bind(this));
    }
  }

  public static getInstance(
    props: ITokenDisplayServiceArgs | {} = {}
  ): TokenDisplayService {
    if (!TokenDisplayService.instance) {
      TokenDisplayService.instance = new TokenDisplayService(props);
    }
    return TokenDisplayService.instance;
  }

  public getTokenDisplayEventBus() {
    return this.tokenDisplayEventBus;
  }

  public disconnectMQTTClient() {
    return this.mqttSrv.disconnect(true);
  }

  async mqttMsgEventHandler(args: any) {
    console.log("mqtt msg received !!!");
    // check if msg available already
    if (!this.qStore) {
      console.log(`initial request, render the packets`);
      this.qStore = args;
      this.tokenDisplayEventBus?.emit("io.vlinder.tokenDisplay", this, args);
      return;
    }
    if (_.isEqual(args, this.qStore)) {
      console.log(`no change in data, ignore the packets but render finger print`);
      // this.tokenDisplayEventBus?.emit("io.vlinder.tokenDisplay.fingerprint", this, {});
      return;
    } else {
      console.log(`data changed, render the packets`);
      this.qStore = args;
      this.tokenDisplayEventBus?.emit("io.vlinder.tokenDisplay", this, args);
      return;
    }
  }

  async getVQMSData(flowId: string) {
    if (flowId) {
      try {
        const res = await axios.get(`https://api-tv-app-tribe.klefki.io/vqms/jobs/${flowId}`, {
          headers: {
            authentication: CONFIG.accessToken
          }
        });
        return res?.data;
      }
      catch(err: any) {
        console.log(`error in VQMS data`)
      }
    }
  }
}
